// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 714 ? "screens" : chunkId) + "." + {"18":"b5dc2eef","130":"d41a53df","133":"d043b4d3","152":"7e3dd612","241":"f751ae74","266":"8e135f72","451":"7a1f10da","464":"abeb2e49","508":"604a0317","714":"f3f89932","752":"4652eb91","769":"3dcb1b3b","832":"5d4b6a39","885":"1f355564"}[chunkId] + ".chunk.js";
};